import { Component } from "react";
import { mainPage } from "../Settings/Config";
import MainHome from "./HomeSub";
import ProductList from "../Products/Product-listing";

class Home extends Component {  
  render() {
    if(mainPage==='product') {
      return (
        <ProductList {...this.props} />
      )
    }else {
      return (
        <MainHome {...this.props} />
      )
    }
  }
}
export default Home;
